export const common = {
  name: "نام",
  title: "عنوان",
  isDeleted: "حذف شده",
  updatedAt: "بروز شده",
  id: "شناسه",
  image: "تصویر",
  type: "نوع",
  next: "بعدی",

};
const translator = {
  "ra-form-layout": {
    action: {
      next: "بعدی",
      previous: "قبلی"
    }
  },
  "ra-search": {
    recent: "تاریخچه جستجو"
  },
  ra: {
    action: {
      create_item: "پیدا نشد - ایجاد",
      create: "ایجاد",
      add_filter: "اضافه‌کردن فیلتر",
      add: "اضافه",
      back: "بازگشت",
      bulk_actions: "۱ آیتم انتخاب شد |||| %{smart_count} عدد از آیتم‌ها انتخاب شدند",
      cancel: "انصراف",
      clear_input_value: "پاک‌کردن مقدار",
      clone: "شبیه‌سازی",
      confirm: "تایید",
      delete: "حذف",
      edit: "ویرایش",
      export: "دریافت خروجی",
      list: "لیست",
      refresh: "بروز‌رسانی",
      remove_filter: "حذف این فیلتر",
      remove: "حذف",
      save: "ذخیره",
      save_and_show: "ارسال درخواست",
      save_and_add: "",
      back_to_list: "بازگشت به لیست",
      restore: "بازگردانی",
      search: "جستجو",
      show: "نمایش",
      sort: "مرتب‌سازی",
      undo: "لغو",
      unselect: "عدم انتخاب",
      expand: "باز کن",
      close: "ببند",
      close_menu: "بستن منو",
      open_menu: "باز کردن منو",
    },
    boolean: {
      true: "بله",
      false: "خیر",
      null: "",
    },
    page: {
      create: "ایجاد %{name}",
      dashboard: "داشبورد",
      edit: "%{name} #%{id}",
      error: "مشکلی ایجاد شد",
      list: "لیست %{name}",
      loading: "در حال بارگذاری",
      not_found: "پیدا نشد",
      show: "%{name} #%{id}",
      empty: "هنوز سطری از %{name} وجود ندارد.",
      invite: "آیا میخواهید یک مورد اضافه کنید؟",
    },
    input: {
      file: {
        upload_several:
          "تعدادی فایل برای آپلود دراپ کنید، یا برای انتخاب آن‌ها کلیک کنید.",
        upload_single:
          "فایلی را برای آپلود انتخاب کنید",
      },
      image: {
        upload_several:
          "تعدادی عکس برای آپلود انتخاب کنید.",
        upload_single:
          "عکسی را برای آپلود انتخاب کنید",
      },
      references: {
        all_missing: "امکان پیدا کردن اطلاعات ارجاعی وجود ندارد.",
        many_missing: "حداقل یکی از مراجع در دسترس نیست.",
        single_missing: "مرجع مورد نظر در دسترس نیست.",
      },
      password: {
        toggle_visible: "پنهان کردن رمز عبور",
        toggle_hidden: "نمایش رمز عبور",
      },
    },
    message: {
      about: "درباره",
      are_you_sure: "آیا اطمینان دارید ؟",
      bulk_delete_content:
        "آیا از حذف  %{name} اطمینان دارید؟ |||| آیا از حدف %{smart_count} عدد از آیتم‌ها اطمینان دارید؟",
      bulk_delete_title:
        "حذف %{name} |||| حذف %{smart_count} عدد از آیتم‌های %{name}",
      delete_content: "آیا از حذف این آیتم اطمینان دارید؟",
      delete_title: "حذف %{name} #%{id}",
      details: "جزییات",
      error: "خطایی در مرورگر رخ داد. درخواست شما کامل نشد",
      invalid_form: "فرم درست پر نشده است. لطفا خطاها را بررسی کنید",
      loading: "صفحه در حال بارگذاری است، چند لحظه صبر کنید",
      no: "خیر",
      not_found:
        "شما یک نشانی اینترنتی اشتباه تایپ کردید یا پیغام بدی را دنبال کردید.",
      yes: "بله",
      unsaved_changes:
        "تغییرات شما ذخیره نشده اند. آیا مطمئن هستید که می خواهید از آنها چشم پوشی کنید؟",
    },
    navigation: {
      no_results: "",
      no_more_results:
        "شماره صفحه‌ی %{page} خارج از محدوده مجاز است. صفحه قبل را امتحان کنید.",
      page_out_of_boundaries: "شماره صفحه %{page} خارج از محدوده است",
      page_out_from_end: "نمی‌توان به بعد از صفحه آخر رفت",
      page_out_from_begin: "نمی‌توان به قبل از صفحه اول رفت",
      page_range_info: "%{offsetBegin}-%{offsetEnd}",
      page_rows_per_page: "",
      next: "بعدی",
      prev: "قبلی",
      skip_nav: "skip_nav"
    },
    auth: {
      auth_check_error: "لطفا برای ادامه وارد شوید",
      user_menu: "پروفایل",
      username: "نام‌کاربری",
      userNumber: "کد پرنسلی",
      password: "رمز عبور",
      sign_in: "ورود",
      sign_in_esign_in_errorrror: "شناسایی با شکست مواجه شد، دوباره تلاش کنید",
      logout: "خروج",
    },
    notification: {
      updated: "المان بروز‌رسانی شد",
      created: "المان ایجاد شد",
      deleted: "المان حذف شد",
      bad_item: "المان اشتباه",
      item_doesnt_exist: "المان پیدا نشد",
      http_error: "خطا در برقراری ارتباط با سرور",
      data_provider_error: "خطا در دریافت اطلاعات",
      canceled: "لغو شد",
      logged_out: "نشست کاربری شما به پایان زسیده‌است، لطفا دوباره وصل شوید.",
    },
    validation: {
      required: "اجباری",
      minLength: "حداقل باید %{min} کارکتر باشد",
      maxLength: "باید %{max} کارکتر یا کمتر باشد",
      minValue: "حداقل باید %{min} باشد",
      maxValue: "باید %{max} یا کمتر باشد",
      number: "باید یک عدد باشد",
      email: "باید یک آدرس ایمیل صحیح باشد",
      oneOf: "باید انتخابی از این گزینه‌ها باشد: %{options}",
      regex: "باید با فرمت خاصی هماهنگ باشد (regexp): %{pattern}",
    },
  },
  Mozaffari: {
    general: {
      generic_err: "خطایی رخ داد",
      invalid_phone_number: "شماره‌تلفن صحیح نمی‌باشد",
      call_manager: 'برای دریافت دسترسی با مدیریت تماس بگیرید',
      send_code: "کد تاییده به شماره‌ی شما پیامک شد",
    },
    menu: {
      marketing: "مارکتینگ",
      users: "کاربران",
      misc: "سایر",
    },
    order: {
      success: "ترتیب تغییر یافت",
      failure: "خطایی در تغییر ترتیب رخ داد!",
    },
  },
  red: {
    user: { HIGH: "oio" },
  },
  resources: {
    adminUsers: {
      name: "همکاران",
      'fields': {
        name: "نام",
        'phoneNumber': "شماره",
        userNumber: "کد پرنسلی",
        role: "دسترسی قدیم",
        roles: "دسترسی ها",
        lastName: "نام خانوادگی",
        fatherNamer: "نام پدر",
        meliNo: "کد ملی",
        insuranceNumber: "شماره بیمه تامین اجتماعی",
        birthCertificateNumber: "شماره شناسنامه",
        birthDate: "تاریخ تولد",
        birthCertificateLocale: "محل تولد",
        birthCertificateIssuanceDate: "تاریخ صدور شناسنامه",
        addressPhoneNumber: "تلفن محل سکونت",
        address: "آدرس محل سکونت",
        relativesName: " یکی از نزدیکان جهت تماس اضطراری",
        relativesAddress: "آدرس",
        relativesPhoneNumber: "تلفن",
        position: "واحد سازمانی",
        baseDailySalary: "پایه حقوق روزانه",
        contractStartDate: "تاریخ شروع قراداد",
        healthCrdValidityDate: "تاریخ اعتبار کارت بهداشت",
        contractEndDate: "تاریخ پایان قراداد",
        healthEducationCertificateValidityDate: "تاریخ اعتبار گواهی آموزش بهداشت",
        numberOfChilds: "تعداد اولاد",
        haghTahol: "حق تاهل",

      },
    },
    productCategory: {
      name: "دسته محصولات",
      fields: {
        icon: "تصویر",
        objectId: "شناسه",
        title: "عنوان",
        order: "ترتیب",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
      },
    },
    product: {
      name: "محصول",
      fields: {
        productCategory: "دسته محصول",
        productCategoryId: "شناسه دسته محصول",
        icon: "تصویر",
        description: "توضیحات",
        isPremium: "اشتراکی",
        referenceUrl: "آدرس مرجع",
        objectId: "شناسه",
        title: "عنوان",
        order: "ترتیب",
        price: " قیمت (ریال)",
        sku: "کد کالا",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
      },
    },
    branch: {
      name: "شعبه ها",
      fields: {
        productCategory: "دسته شعبه",
        productCategoryId: "شناسه دسته شعبه",
        icon: "تصویر",
        description: "توضیحات",
        isPremium: "اشتراکی",
        referenceUrl: "آدرس مرجع",
        objectId: "شناسه",
        title: "عنوان",
        order: "ترتیب",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
      },
    },
    need: {
      WHOLESALE: "فروض عمده",
      name: "درخواست ",
      fields: {
        attachment: "سند",
        description: "توضیحات",
        descript: "توضیحات",
        refNum: "کد پیگیری",
        typeOfNeed: "نوع درخواست",
        UnitProcessor: "واحد مربوطه",
        objectId: "شناسه",
        title: "عنوان",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        products: "اقلام",
        customerName: "نام مشتری",
        customerNumber: "شماره مشتری",
      },
    },
    unit: {
      name: "واحد ",
      fields: {
        title: "عنوان",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        order: "ترتیب",
        hideInreport: "انبار ندارد"
      },
    },
    whatsapp: {
      name: "واتس اپ ",
      fields: {
        title: "عنوان",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        phoneNumber: "شماره همراه"
      },
    },
    package: {
      name: "نوع بسته بندی",
      fields: {
        title: "عنوان",
        order: "ترتیب",

      }
    },
    orderType: {
      name: "نو سفارش",
      fields: {
        title: "عنوان",
        order: "ترتیب",

      }
    },
    status: {
      name: "وضعیت درخواست",
      hints: {
        messageTemplate: "مثال  \n یادآوری درخواست   {Title}) (عنوان درخواست )  , {NL} (خط بعدی) لطفا وضعیت در خواست را مشخص بفرمایید ، وضعیت کنونی {Status} (وضعیت)  ، {NL} کد پیگیری  {RefNum} (کد پیگیری)"
      }
    },
    customer: {
      name: " مشتری ",
      fieldGroups: {
        identity: "مشخصات"
      },
      fields: {
        credit: "اعتبار مشتری",
        discountLimit: "سقف تخفیف",
        lastPurchaseDate: "تاریخ آخرین خرید",
        priority: "",
        category: "",
        rank: "",
        name: " نام ",
        order: "ترتیب",
        // typeOfCustomer: " نوع مخاطب ",
        connectors: " مخاطب / رابط ",
        companies: "شرکت‌ها",
        contactPriorityId: "الویت تماس",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        economicCode: "کد اقتصادی",
        meliCode: "کد ملی",
        email: "ایمیل",
        shenaseMeli: "شناسه ملی",
        address: "آدرس",
        postalCode: "کد پستی",
        refer: "معرف",
        description: "توضیحات",
        tasvieCond: "شرایط تسویه",
        customerRefId: "نام کاربری مشتری",
        phoneNumber: "شماره ",
        phoneNumbers: "تلفن ها",
        number: "شماره",
        customerCategoryId: 'دسته‌بندی ',
        customerRatingId: 'رتبه مشتری"',
        customerPriorityId: 'الویت‌بندی مشتری',
        users: 'همکاران',
        contact: 'رابط‌ها',
        approved: 'تایید/ عدم تایید - هویت مشتری',
        newTransaction: "افزودن"
      },
    },
    contact: {
      name: " مخاطب ",
      fieldGroups: {
        identity: "مشخصات"
      },
      fields: {
        name: " نام ",
        // typeOfCustomer: " نوع مخاطب ",
        order: "ترتیب",

        connectors: " رابط‌ها ",
        companies: "شرکت‌ها",
        contactPriorityId: "الویت تماس",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        economicCode: "کد اقتصادی",
        meliCode: "کد ملی",
        email: "ایمیل",
        shenaseMeli: "شناسه ملی",
        address: "آدرس",
        postalCode: "کد پستی",
        refer: "معرف",
        description: "توضیحات",
        tasvieCond: "شرایط تسویه",
        contactRefId: "نام کاربری مخاطب",
        phoneNumber: "شماره ",
        phoneNumbers: "تلفن ها",
        number: "شماره"

      },
    },
    customerCategory: {
      name: "دسته‌بندی مشتری ",
      fields: {
        title: "عنوان",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        order: "ترتیب",
      },
    },
    contactCategory: {
      name: "دسته‌بندی مخاطب ",
      fields: {
        title: "عنوان",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        order: "ترتیب",
      },
    },
    customerRating: {
      name: "رتبه مشتری ",
      fields: {
        title: "عنوان",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        order: "ترتیب",
      },
    },
    customerPriority: {
      name: "الویت‌بندی مشتری ",
      fields: {
        title: "عنوان",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        order: "ترتیب",
      },
    },
    clue: {
      name: "سرنخ ",
      fields: {
        title: "عنوان",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        order: "سفارش",
        callResult: 'وضعیت تماس',
        description: 'توضیحات',

      },
    },
    notifications: {
      name: "اعلان‌ها ",
      fields: {
        title: "عنوان",
        content: "متن",
        type: "نوع",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        unread: "وضعیت",
        callResult: 'وضعیت تماس',
        description: 'توضیحات',
      },
    },
    transaction: {
      name: "تراکنش‌ ",
      fields: {
        title: "عنوان",
        date: "تاریخ",
        description: "شرح",
        invoiceId: "شماره فاکتور",
        customerId: "مشتری",
        updatedAt: "بروز شده",
        createdAt: "زمان ایجاد",
        amount: "مبلغ",
        count: 'تعداد',
        createdBy: "توسط",
      },
    },
    paybills: {
      name: "فیش حقوقی",
      fields: {
        order: 'ردیف',
        month: 'ماه',
        year: 'سال',
        userName: 'نام همکار',
        userNumber: 'کد پرنسلی',
        userPhoneNumber: 'شماره تلفن ',
        numberOfWorkingDays: 'تعداد روز کارکرد',
        numberOfWorkingHours: 'تعداد ساعت کارکرد',
        numberOfAdditionalWorkHours: 'ساعت اضافه کاری',
        numberOfUnderWorkHours: 'ساعت کسر کار',
        childAllowance: 'حق اولاد',
        leave: 'مرخصی',
        officialHolidays: 'تعطیلات رسمی',
        basicDailySalary: 'پایه حقوق روزانه',
        baseYearsSalary: 'پایه سنوات',
        assistanceReceived: 'مساعده دریافتی',
        holidaysAndBaseYearandLeaveBalance: 'عیدی و سنوات و مانده مرخصی',
        lunch: 'نهار',
        buy: 'خرید ',
        loan: 'وام',
        insuranceDeduction: 'کسر حق بیمه سهم کارپذیر',
        reward: 'پاداش',
        otherDeductions: 'سایر کسورات',
        monthlySalary: 'حقوق ماه',
        balanceReceived: 'مانده دریافتی',
        readAndAgreeByUserDate: 'تاریخ مشاهده همکار',
        readAndAgreeByUser: 'تایید شده',
        previousDebt: 'بدهی قبلی',
        iban: 'شماره حساب',
        description: 'توضیحات',
        commentBeforeBill: 'پیام قبل نمایش فیش حقوقی',
        updatedAt: "بروز شده",
        createdAt: "زمان ایجاد",


      }
    },
    request: {
      name: "درخواست‌ها",
      fields: {
        title: "عنوان",
        type: "نوع درخواست",
        status: "وضعیت",
        description: "توضیحات",
        adminResponse: "پاسخ ادمین",
        createdAt: "تاریخ ایجاد",
        attachment: "فایل پیوست",
        status_pending: "در انتظار بررسی",
        status_approved: "تایید شده",
        status_rejected: "رد شده",
        type_leave: "درخواست مرخصی",
        type_loan: "درخواست وام",
        type_employment_letter: "درخواست نامه اشتغال به کار",
        type_other: "سایر",
        type_advance_payment: "درخواست مساعده",
        type_salary_slip: "درخواست فیش حقوق",
        type_salary_slip_discrepancy: "درخواست بررسی مغایرت در فیش حقوق"
      }
    }



  }
};
export default translator;
